export const statusFilters = Object.freeze({
  all: "all",
  online: "online",
  offline: "offline",
});
